<template>
    <div class="slide">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="1"
                    :total="4"
                    :selectAll=true />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-8",
            currentTrivia: 7,
            questions: {
                question: {
                    "title": "Why is it vital to report KTs in case management?",
                    "answers": [
                        {"key": "A", "answer": "They provide additional information that could be valuable later"},
                        {"key": "B", "answer": "It isn’t vital"},
                        {"key": "C", "answer": "It aids the investigation when we must get Law Enforcement involved"},
                    ],
                    "correctAnswer": ["A", "C"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>

</style>
